module.exports = __webpack_public_path__ + "d8a59881b96f62460c0ea880da05dbbc.svg";